import { createFileRoute } from '@tanstack/react-router';
import { QueuesPage } from '@/pages/admin/system-monitor/queues-page';

export const Route = createFileRoute(
  '/admin/_layout/system-monitor/_layout/queues'
)({
  component: QueuesPage,
});
